// src/components/HelpModal.jsx
import React from "react";

export default function HelpModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Ajuda da tela de Leads"
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,.35)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 60,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: 640, maxWidth: "90vw", background: "#fff", borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0,0,0,.2)", overflow: "hidden"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "14px 16px", borderBottom: "1px solid #e5e7eb", fontWeight: 800 }}>
          Como usar a lista de Leads
        </div>
        <div style={{ padding: 16, fontSize: 14, color: "#374151", lineHeight: 1.5 }}>
          <ol style={{ paddingLeft: 18, margin: 0 }}>
            <li><b>Busca rápida:</b> digite na barra de busca (atalho <code>/</code>) para filtrar por nome, código ou e-mail.</li>
            <li><b>Status em um clique:</b> use as pílulas de status para filtrar (ex.: <i>NOVO</i>, <i>PROPOSTA</i>).</li>
            <li><b>Ordenação:</b> clique no cabeçalho da coluna (ex.: <i>Nome</i>, <i>Valor</i>, <i>Criado em</i>) para alternar ASC/DSC.</li>
            <li><b>Página e limite:</b> use os botões <i>Anterior/Próxima</i> e o seletor de itens por página.</li>
            <li><b>Abrir detalhes:</b> clique em uma linha para ver/editar o lead.</li>
            <li><b>Novo lead:</b> botão <i>Novo Lead</i> (atalho <code>n</code>).</li>
            <li><b>Atualizar:</b> botão <i>Atualizar</i> (atalho <code>r</code>).</li>
          </ol>
          <div style={{ marginTop: 12, fontSize: 13, color: "#6b7280" }}>
            Dica: os filtros ficam gravados na URL. Você pode salvar um favorito no navegador com o filtro que usa no dia a dia.
          </div>
        </div>
        <div style={{ padding: 12, borderTop: "1px solid #e5e7eb", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button
            onClick={onClose}
            style={{ border: "1px solid #e5e7eb", background:"#fff", borderRadius: 10, padding: "8px 12px", fontWeight: 700, cursor: "pointer" }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
